import type { ReactElement, ReactNode } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';

interface SortableRowProps {
    id: string;
    children: ReactNode;
}

export function SortableRow({ id, children }: SortableRowProps): ReactElement {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
        useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1
    };

    return (
        <div ref={setNodeRef} style={style} className="flex items-stretch">
            <button
                type="button"
                {...attributes}
                {...listeners}
                aria-label="Перетащить"
                className="flex cursor-grab items-center px-2 text-gray-400 hover:text-gray-700 active:cursor-grabbing"
                data-testid={`drag-handle-${id}`}
            >
                <GripVertical size={16} />
            </button>
            <div className="flex-1">{children}</div>
        </div>
    );
}
